import Emitter from '../core/emitter.js'

import { NotificationSimpleClass } from './NotificationSimple.js'

export default window.customElements.define(
  'notification-cookie',
  class extends NotificationSimpleClass {
    isCookie = true

    constructor() {
      super()
      this.events = {
        ...this.events,
        'click .js-notification-cookie-accept': 'onAccept',
        'click .js-notification-cookie-deny': 'onDeny'
      }
    }

    connectedCallback() {
      super.connectedCallback()

      Emitter.on('document:ready', this.init.bind(this))
    }

    disconnectedCallback() {
      super.disconnectedCallback()
    }

    init() {
      this.accepted = !!localStorage.getItem('accepted-cookie')
      if (this.accepted) {
        this.track()
      }

      setTimeout(() => {
        if (!this.accepted) {
          Emitter.emit('notification:stack', { notification: this, order: -1 })
        }
        Emitter.emit('cookie-ready', { accepted: this.accepted })
      }, 10)
    }

    track() {
      window.startTracking && startTracking()
    }

    onAccept(e) {
      e.preventDefault()

      localStorage.setItem('accepted-cookie', true)

      this.track()

      this.close()
    }

    onDeny(e) {
      e.preventDefault()

      this.close()
    }
  }
)
